import React from 'react';
import CircularProgress from '@mui/material/CircularProgress'

export default function Spinner({ loading, text = '' }) {

    if (!loading) return null;

    return (
        <div className="spinner">
            <div>
                <CircularProgress />
                <div className="spinner__text">{text}</div>
            </div>
        </div>
    )
}
